<template>
    <div class="resident-invitation" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Enrollment Invitation
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <div class="open-wrapper pointer" @click="openModal">
                            <slot>
                                <a href="javascript://void(0)" class="btn btn-success">Send Invitation</a>
                            </slot>
                        </div>
                    </div>
                </div>
            </legend>

            <ul class="list-group no-margin">
                <li class="list-group-item" v-for="emailNotification in emailNotifications">
                    <h5 class="text-bold margin-sm-bottom">
                        {{emailNotification.subject}}
                    </h5>

                    <h6 class="margin-sm-bottom">
                        Sent To: {{emailNotification.to}}
                    </h6>

                    <h6 class="margin-sm-bottom">
                        Sent By: {{emailNotification.user.fullName}}
                    </h6>

                    <div>
                        <span class="label label-success" v-if="emailNotification.sent_at !== null">
                            Sent at {{emailNotification.sent_at}}
                        </span>
                        <span class="label label-primary" v-else-if="emailNotification.scheduled_at !== null">
                            Scheduled for {{emailNotification.scheduled_at}}
                        </span>
                        <span class="label label-primary" v-else>
                            Scheduled
                        </span>
                    </div>
                </li>
            </ul>

            <modal :name=modalId
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
                <div class="dashboard-block">
                    <header>
                        <h4>Send Resident Invitation</h4>
                    </header>

                    <p v-if="resident">Send invitation to <strong>{{resident.fullName}} ({{resident.email}})</strong>?
                    </p>

                    <div class="row">
                        <div class="col-xs-6">
                            <button type="button" class="btn btn-default" @click="$modal.hide( modalId )">
                                Cancel
                            </button>
                        </div>
                        <div class="col-xs-6 text-right">
                            <button class="btn btn-success" @click="send">
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </fieldset>
    </div>
</template>

<script>
    export default {
        props: {
            residentId: {
                type: String,
                required: true
            },

            modalId: {
                default: function(){
                    return Math.random().toString();
                },
                type: String
            },

            afterSave: {
                default: function(){
                    return function(){
                    };
                }
            }
        },

        created: function(){
            var self = this;
            this.loading = true;

            return Promise.all( [
                self.loadResident(),
                self.loadEmailNotifications()
            ] )
                .then( function(){
                    self.loading = false;
                } );
        },

        data: function(){
            return {
                loading: true,
                emailNotifications: [],
                resident: null,
            };
        },

        methods: {
            loadResident: function(){
                var self = this;
                var url = '/api/residents/' + this.residentId;

                return axios.get( url )
                    .then( function( response ){
                        var resident = response.data.Resident;

                        self.$set( self, 'resident', resident );
                    } );
            },

            loadEmailNotifications: function(){
                var self = this;
                var url = '/api/emailNotifications?notifiable_type=App\\Resident&notifiable_id=' + this.residentId;

                return axios.get( url )
                    .then( function( response ){
                        var emailNotifications = response.data.EmailNotifications;

                        self.$set( self, 'emailNotifications', emailNotifications );
                    } );
            },

            send: function(){
                var self = this;
                var url = '/api/residents/' + this.residentId + '/invite';
                self.loading = true;

                return axios.post( url )
                    .then( function(){
                        return self.loadEmailNotifications();
                    } )
                    .then( function(){
                        self.afterSave();

                        self.$modal.hide( self.modalId );

                        self.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Sent Invitation to ' + self.resident.email,
                        } );

                        self.loading = false;
                    } )
                    .catch( function( err ){
                        console.error( err );

                        self.$notify( {
                            type: 'danger',
                            placement: 'top-left',
                            title: 'Something went wrong, please refresh your browser and try again',
                        } );
                    } );
            },

            openModal: function(){
                this.$modal.show( this.modalId );
            }
        }
    }
</script>